import {
  put, takeLatest, all, select,
} from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import GRNActions, { grnActionTypes } from '../actions/grnActions';
import GRNServices from '../services/grnServices';

/**
 * @param action
 */
function* _getDownloadGRNData(action) {
  const {
    payload, callback,
  } = action;
  try {
    yield put(GRNActions.getDownloadGRNDataLoading(true));
    const grnData = yield GRNServices.downloadGRNData(payload);
    if (grnData?.success) {
      notification.open({
        type: 'success',
        message: 'Your request is being processed. You will receive the data on your email.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: grnData?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(GRNActions.getDownloadGRNDataLoading(false));
  } catch (error) {
    yield put(GRNActions.getDownloadGRNDataLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(grnActionTypes.GET_DOWNLOAD_GRN_DATA.ERROR, error));
  }
}

function* downloadGRNData() {
  yield takeLatest(grnActionTypes.GET_DOWNLOAD_GRN_DATA.REQUEST, _getDownloadGRNData);
}

/**
 * @param action
 */
function* _updateGRNStatus(action) {
  try {
    yield put(GRNActions.updateGRNStatusLoading(true));
    const grn = yield GRNServices.updateGRNStatus(action.payload);
    if (grn.success) {
      notification.open({
        type: 'success',
        message: 'Goods receiving note status updated successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(GRNActions.updateGRNStatusLoading(false));
      if (action?.callback) action.callback(grn);
    } else {
      notification.open({
        type: 'error',
        message: grn?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(GRNActions.updateGRNStatusLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(GRNActions.updateGRNStatusLoading(false));
    yield put(TrackerActions.trackAction(grnActionTypes.UPDATE_GRN_STATUS.ERROR, error));
  }
}

/**
 *
 */
function* updateGRNStatus() {
  yield takeLatest(grnActionTypes.UPDATE_GRN_STATUS.REQUEST, _updateGRNStatus);
}

/**
 * @param action
 */
function* _addGRN(action) {
  try {
    yield put(GRNActions.createGRNLoading(true));
    const grn = yield GRNServices.createGRN(action.payload);
    if (grn.success) {
      yield put(TrackerActions.trackAction(grnActionTypes.CREATE_GRN.SUCCESS, grn.data));
      notification.open({
        type: 'success',
        message: 'Goods receiving note has been created successfully',
        duration: 4,
        placement: 'top',
      });
      action.callback(grn);
      yield put(GRNActions.createGRNLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: grn.message,
        duration: 4,
        placement: 'top',
      });
      yield put(GRNActions.createGRNLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(GRNActions.createGRNLoading(false));
    yield put(TrackerActions.trackAction(grnActionTypes.CREATE_GRN.ERROR, error));
  }
}

/**
 *
 */
function* addGRN() {
  yield takeLatest(grnActionTypes.CREATE_GRN.REQUEST, _addGRN);
}

/**
 * @param action
 */
function* _updateGRN(action) {
  try {
    yield put(GRNActions.updateGRNLoading(true));
    const grn = yield GRNServices.updateGRN(action.payload);
    if (grn.success) {
      yield put(TrackerActions.trackAction(grnActionTypes.UPDATE_GRN.SUCCESS, grn.data));
      notification.open({
        type: 'success',
        message: 'GRN successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(GRNActions.updateGRNLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: grn?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(GRNActions.updateGRNLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(GRNActions.updateGRNLoading(false));
    yield put(TrackerActions.trackAction(grnActionTypes.UPDATE_GRN.ERROR, error));
  }
}

/**
 *
 */
function* updateGRN() {
  yield takeLatest(grnActionTypes.UPDATE_GRN.REQUEST, _updateGRN);
}

/**
 * @param action
 */
function* _quickUpdateGRN(action) {
  try {
    const state = yield select();
    const { selectedGRN } = state?.GRNReducers;
    let selectedGRN1 = JSON.parse(JSON.stringify(selectedGRN));
    const selectedGRN2 = JSON.parse(JSON.stringify(selectedGRN));
    selectedGRN1 = { ...selectedGRN1, ...action.payload };
    yield put(GRNActions.getGRNByIdSuccess(selectedGRN1));
    yield put(GRNActions.quickUpdateGRNLoading(true));
    const grn = yield GRNServices.quickUpdateGRN(action.payload);
    if (grn.success) {
      notification.open({
        type: 'success',
        message: 'Updating GRN successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: grn.message || 'Error! while updating grn',
        duration: 4,
        placement: 'top',
      });
      if (action?.rollback) {
        action?.rollback();
      }
      yield put(GRNActions.getGRNByIdSuccess(selectedGRN2));
    }
    yield put(GRNActions.quickUpdateGRNLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(GRNActions.quickUpdateGRNLoading(false));
  }
}

/**
   *
   */
function* quickUpdateGRN() {
  yield takeLatest(grnActionTypes.QUICK_UPDATE_GRN.REQUEST, _quickUpdateGRN);
}

/**
 * @param action
 */
function* _getGRN(action) {
  try {
    yield put(GRNActions.getGRNLoading(true));
    const {
      tenantId, grnId, grnEntityId, grnEntityType, status, limit, page, tenantSellerId, selectedEntityType, searchKeyword, sellerId, startDate, endDate, scheduleGrn, paymentStatus, grnFromDueDate, grnToDueDate, tags, departmentIds, sourceOfGrn, callback, excludeGRNIds, excludeGRNVendorIds, is_list, billingStatus
    } = action;
    const getGRNData = yield GRNServices.getGRN(tenantId, grnId, grnEntityId, grnEntityType, status, limit, page, tenantSellerId, selectedEntityType, searchKeyword, sellerId, startDate, endDate, scheduleGrn, paymentStatus, grnFromDueDate, grnToDueDate, tags, departmentIds, sourceOfGrn, excludeGRNIds, excludeGRNVendorIds, is_list, billingStatus);
    yield put(GRNActions.getGRNSuccess(getGRNData));
    if (callback) callback(getGRNData)
    yield put(GRNActions.getGRNLoading(false));
  } catch (error) {
    yield put(GRNActions.getGRNLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(grnActionTypes.GET_GRN.ERROR, error));
  }
}

/**
 *
 */
function* getGRN() {
  yield takeLatest(grnActionTypes.GET_GRN.REQUEST, _getGRN);
}

/**
 * @param action
 */
function* _getGRNById(action) {
  try {
    yield put(GRNActions.getGRNByIdLoading(true));
    const {
      tenantId, grnId, callback,
    } = action;
    const selectedGRN = yield GRNServices.getGRN(tenantId, grnId);
    yield put(GRNActions.getGRNByIdSuccess(selectedGRN?.grn?.[0]));
    if (callback) {
      callback(selectedGRN?.grn?.[0]);
    }
    yield put(GRNActions.getGRNByIdLoading(false));
  } catch (error) {
    yield put(GRNActions.getGRNByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(grnActionTypes.GET_GRN.ERROR, error));
  }
}

/**
 *
 */
function* getGRNById() {
  yield takeLatest(grnActionTypes.GET_GRN_BY_ID.REQUEST, _getGRNById);
}

/**
 * @param action
 */
function* _deleteGrn(action) {
  try {
    yield put(GRNActions.deleteGrnLoading(true));
    const {
      tenantId, grnId,
    } = action;
    const deletedGrn = yield GRNServices.deleteGrn(tenantId, grnId);
    if (deletedGrn?.success) {
      notification.open({
        type: 'success',
        message: 'Goods receiving note deleted successfully',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: deletedGrn?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(GRNActions.deleteGrnLoading(false));
  } catch (error) {
    yield put(GRNActions.deleteGrnLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(grnActionTypes.DELETE_GRN.ERROR, error));
  }
}

/**
 *
 */
function* deleteGrn() {
  yield takeLatest(grnActionTypes.DELETE_GRN.REQUEST, _deleteGrn);
}

/**
 *
 */

function* _updateGRNWorkflowStep(action) {
  try {
    yield put(GRNActions.updateGRNWorkflowStepLoading(true));
    const { payload } = action;
    const GoodsReceivingNote = yield GRNServices.updateGRNWorkflowStep(payload);
    if (GoodsReceivingNote.success) {
      notification.open({
        type: 'success',
        message: 'GRN approval status updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(GoodsReceivingNote);
      }
    } else {
      notification.open({
        type: 'error',
        message: GoodsReceivingNote.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(GRNActions.updateGRNWorkflowStepLoading(false));
  } catch (error) {
    yield put(GRNActions.updateGRNWorkflowStepLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(grnActionTypes.UPDATE_GRN_WORKFLOW_STEP.ERROR, error));
  }
}

/**
 *
 */
function* updateGRNWorkflowStep() {
  yield takeLatest(grnActionTypes.UPDATE_GRN_WORKFLOW_STEP.REQUEST, _updateGRNWorkflowStep);
}

function* _sendGRNMailToVendor(action) {
  try {
    yield put(GRNActions.sendGRNMailToVendorLoading(true));
    const mailResponse = yield GRNServices.sendGRNMailToVendor(action.payload);
    if (mailResponse?.success) {
      if (action.callback) {
        action.callback();
      }
      notification.open({
        type: 'success',
        message: 'Purchase order sent to vendor successfully.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: mailResponse?.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (action.callback) {
      action.callback();
    }
    yield put(GRNActions.sendGRNMailToVendorLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(grnActionTypes.SEND_GRN_EMAIL_TO_VENDOR.ERROR, error));
    yield put(GRNActions.sendGRNMailToVendorLoading(false));
  }
}

function* sendGRNMailToVendor() {
  yield takeLatest(grnActionTypes.SEND_GRN_EMAIL_TO_VENDOR.REQUEST, _sendGRNMailToVendor);
}

export default function* grnSaga() {
  yield all([
    addGRN(), getGRN(), updateGRNStatus(), updateGRN(), getGRNById(), deleteGrn(), downloadGRNData(), updateGRNWorkflowStep(), quickUpdateGRN(), sendGRNMailToVendor(),
  ]);
}
